export default "__VITE_ASSET__DX4mISAT__"